







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";


@Component({
    components: {},
})
export default class ImgPreview extends Vue {
    @Prop() profileImg!: string;
    @Prop() bannerImg!: string;
    private profileImgSrc: string = this.profileImg;
    private bannerImgSrc: string = this.bannerImg;



}
